import { Injectable } from '@angular/core';
import { Headers, RequestOptions } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { WP_API_URL } from 'app/config';

import { CorpoDirigente } from 'models/corpo-dirigente';

export const CORPO_DIRIGENTE_API_URL = WP_API_URL + '/corpo-dirigente';

@Injectable()
export class CorpoDirigenteService {

  private options: RequestOptions;

  constructor(private _http: HttpClient) {
    this.options = new RequestOptions({
      headers: new Headers({ 'Content-Type': 'application/json' }),
    });
  }

  query(query: any = {}): Observable<CorpoDirigente[]> {
    const filtro: any = {
      '_embed': true,
      per_page: 50,
    };

    return this._http
      .get<Array<any>>(CORPO_DIRIGENTE_API_URL, Object.assign({}, this.options, { params: filtro }))
      .map(resp => resp.map(item => this.postToCorpoDirigente(item)));
  }

  private postToCorpoDirigente(post: any): CorpoDirigente {
    const dirigente = new CorpoDirigente();

    dirigente.id = post.id;
    dirigente.date = post.date;
    dirigente.nome = post.title.rendered;
    dirigente.cargo = post.cargo;
    dirigente.sobre = post.sobre;

    if (post._embedded) {

      // featuredMedia
      if (post._embedded['wp:featuredmedia']) {
        const sizes = post._embedded['wp:featuredmedia'][0].media_details.sizes;
        const mediaSize = sizes.full || sizes.corpo_dirigente_full;
        dirigente.featuredMedia = {
          canvas: mediaSize,
          thumbnail: mediaSize,
        };
      }

    }

    return dirigente;
  }

}
